import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FilterPipe } from './pipe/filter.pipe';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import {
  CustomErrorStateMatcher,
  Environment,
  ServicesModule
} from '@auth-suite-services/services';
import { MBEServiceModule } from '@auth-suite-services/mbe-service';

import { environment } from '../environments/environment';
const config: Environment = environment;

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { ErrorStateMatcher, MAT_DATE_LOCALE } from '@angular/material/core';
import { CacheInterceptor } from './cache-interceptor';
import { SuredebitSetupModule } from '@auth-suite-services/suredebit-setup';

// NgApexcharts removed from root — lazy feature modules import it themselves 28/10/2026 DW
// SpiRoutingModule removed from root — merchant admin already lazy-loaded via /mad 28/10/2026 DW
@NgModule({
  declarations: [AppComponent, FilterPipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
    TablerIconsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ServicesModule.forRoot(config),
    SuredebitSetupModule.forRoot(config),
    MBEServiceModule.forRoot(config),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: ErrorStateMatcher, useClass: CustomErrorStateMatcher },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  exports: [TablerIconsModule],
  bootstrap: [AppComponent]
})
export class AppModule {}
